import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp } from 'lucide-react';
export function MarketContext() {
  return <section className="py-24 px-6 bg-zinc-950" data-id="element-59">
      <div className="max-w-4xl mx-auto" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex items-center gap-3 mb-8" data-id="element-61">
          <div className="w-10 h-10 rounded-full bg-magenta-500/10 flex items-center justify-center" data-id="element-62">
            <TrendingUp className="w-5 h-5 text-magenta-500" data-id="element-63" />
          </div>
          <span className="text-sm uppercase tracking-widest text-zinc-500 font-medium" data-id="element-64">
            The opportunity
          </span>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="font-serif text-2xl md:text-4xl leading-snug text-zinc-200 mb-12" data-id="element-65">
          OnlyFans launched in 2016 and crossed into{' '}
          <span className="text-magenta-500" data-id="element-66">billion-dollar revenue</span> by
          2020 — a meteoric four-year rise built on the creator economy and
          direct-to-consumer demand.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-12" data-id="element-67">
          <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6" data-id="element-68">
            <p className="font-serif text-4xl text-cyan-300 mb-2" data-id="element-69">2016</p>
            <p className="text-sm text-zinc-500" data-id="element-70">
              Launched as a subscription-based platform for creators.
            </p>
          </div>
          <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6" data-id="element-71">
            <p className="font-serif text-4xl text-magenta-500 mb-2" data-id="element-72">$1B+</p>
            <p className="text-sm text-zinc-500" data-id="element-73">
              Revenue range crossed by 2020 — just four years in.
            </p>
          </div>
          <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6" data-id="element-74">
            <p className="font-serif text-4xl text-zinc-200 mb-2" data-id="element-75">D2C</p>
            <p className="text-sm text-zinc-500" data-id="element-76">
              Direct-to-consumer creator economy still expanding.
            </p>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        delay: 0.3
      }} className="text-lg text-zinc-400 font-light leading-relaxed" data-id="element-77">
          The market is proven, the demand is global, and the playbook is open.{' '}
          <span className="text-zinc-200 font-medium" data-id="element-78">Dance for Fans</span> is
          positioned to enter that same wave — with a sharper, dance-first
          identity.
        </motion.p>
      </div>
    </section>;
}